const PERSONS = new Map([
  [0, "eu",],
  [1, "tu",],
  [2, ["você", "ele", "ela"],],
  [3, "nós",],
  [4, "vós",],
  [5, ["vocês", "eles", "elas"]]
]);

export default PERSONS;